import PageBaseButton from './PageBaseButton';

interface ResetButtonProps {
  onClick: () => void;
}

const ResetButton = ({ onClick }: ResetButtonProps) => {
  return (
    <PageBaseButton
      variant="outline-primary"
      buttonText="リセット"
      onClick={onClick}
    />
  );
};

export default ResetButton;
